import * as articlesActions from './articles.actions';
import { ArticlesState, initialState, ArticlesReducersState } from './articles.state';
import { ActionReducerMap } from '@ngrx/store';

export function reducer(state: ArticlesState = initialState, action: articlesActions.ArticlesAction): ArticlesState {
  switch (action.type) {
    case articlesActions.GET_ALL_ARTICLES: {
      return {
        ...state,
        articles: {
          ...state.articles,
          loading: true,
        },
      };
    }

    case articlesActions.GET_ALL_ARTICLES_SUCCESS: {
      const articles = action.payload;

      return {
        ...state,
        articles: {
          ...articles,
          loaded: true,
          loading: false,
        },
      };
    }

    case articlesActions.GET_ALL_ARTICLES_FAIL: {
      const articles = state.articles.results.length === 0 ? [] : state.articles.results;
      return {
        ...state,
        articles: {
          ...state.articles,
          results: articles,
          loading: false,
          loaded: false,
        },
      };
    }

    case articlesActions.VIEW_ARTICLE: {
      return {
        ...state,
        article: {
          ...state.article,
          loading: true,
        },
      };
    }

    case articlesActions.VIEW_ARTICLE_SUCCESS: {
      const article = action.payload;
      return {
        ...state,
        article: {
          ...article,
          loaded: true,
          loading: false,
        },
      };
    }

    case articlesActions.VIEW_ARTICLE_FAIL: {
      return {
        ...state,
        article: {
          ...state.article,
          loaded: false,
          loading: false,
        },
      };
    }

    case articlesActions.CLEAR_ARTICLE: {
      return {
        ...state,
        article: {
          ...initialState.article,
        },
      };
    }

    case articlesActions.CLEAR_ALL_ARTICLES: {
      return {
        ...state,
        articles: {
          ...initialState.articles,
        },
      };
    }

    default: {
      return state;
    }
  }
}

export const articlesReducer: ActionReducerMap<ArticlesReducersState> = {
  data: reducer,
};
